import { Observable } from '../Observable';
import { createOperatorSubscriber } from './OperatorSubscriber';
import { noop } from '../util/noop';
export function ignoreElements() {
    return function (source) {
        return new Observable(function (subscriber) {
            source.subscribe(createOperatorSubscriber(subscriber, noop));
        });
    };
}
//# sourceMappingURL=ignoreElements.js.map